import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, RouterStateSnapshot} from '@angular/router';
import {Observable} from 'rxjs';
import {Watchlist, WatchlistService} from '../../components/watchlist';

@Injectable()
export class WatchlistsResolverService {

    constructor(
        private watchlistService: WatchlistService
    ) {}

    public resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<Watchlist[]> {
        return this.watchlistService.fetchWatchlistsFromServer();
    }

}
